<template>
    <div id="app">
        <div v-if="isAuthenticated">
            <NavbarMenu/>
            <keep-alive>
                <transition name="fade" mode="out-in">
                    <router-view class="view"></router-view>
                </transition>
            </keep-alive>
          <TheFooter />
        </div>
        <div v-else>
            <Login/>
        </div>
        <notifications/>
    </div>
</template>

<style>
html, body {
    height: 100%;
    margin: 0;
}

#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    font-size: 12px;
    min-height: 100%; 
    display: flex;
    flex-direction: column;
}

#app > div {
    flex: 1;  
    display: flex;
    flex-direction: column;
}

#app > div > .view {
    flex: 1;  
}

</style>
<script>
    import {mapGetters} from "vuex";
    import Login from "./views/LoginPage"
    import NavbarMenu from "./components/layout/TheHeader";
    import TheFooter from "./components/layout/TheFooter"
    export default {
        components: { NavbarMenu, Login,TheFooter},
        computed: {
            ...mapGetters("auth", ["isAuthenticated"])
        }
    }
</script>
